"use client";

import Image from "next/image";
import { motion } from "framer-motion";

const bonuses = [
  {
    num: "01",
    title: "Free Design Prototype",
    description: "Experience your design in action before development.",
    icon: "/assets/bonuses/Design-Prototype.svg",
  },
  {
    num: "02",
    title: "Developer Handoff",
    description: "We ensure what we design is exactly what gets built.",
    icon: "/assets/bonuses/Developer-Handoff.svg",
  },
  {
    num: "03",
    title: "Project Management",
    description: "Stay on track with our expert project management.",
    icon: "/assets/bonuses/Project-Management.svg",
  },
  {
    num: "04",
    title: "$30 Discovery Call",
    description: "30-min paid consultation — credited toward your project.",
    icon: "/assets/bonuses/Project-Consultation.svg",
  },
];

export default function Bonuses() {
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-surface relative overflow-hidden">
      <div className="max-w-[960px] mx-auto px-6 relative z-10">
        <motion.div
          className="text-center mb-14"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <p className="section-badge mb-4 mx-auto">Included Free</p>
          <h2 className="text-2xl sm:text-3xl md:text-[48px] font-bold leading-[1.2] font-ui">
            <span>Bonuses Worth </span>
            <span className="font-serif italic text-purple-light">$2,500</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {bonuses.map((bonus, i) => (
            <motion.div
              key={i}
              className="bg-surface-light border border-card-border rounded-2xl p-4 sm:p-5 md:p-6 hover:border-foreground/10 transition-all duration-300 group h-full flex flex-col"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 relative flex-shrink-0">
                  <Image src={bonus.icon} alt={bonus.title} fill className="object-contain object-left theme-invert opacity-70 group-hover:opacity-100 transition-opacity" />
                </div>
                <span className="text-2xl font-bold bg-gradient-to-b from-[#E11D24] to-[#E11D24]/20 bg-clip-text text-transparent font-ui">{bonus.num}</span>
              </div>
              <h3 className="text-sm font-bold font-ui mb-2 group-hover:text-foreground transition-colors">{bonus.title}</h3>
              <p className="text-xs text-foreground/40 font-body leading-relaxed flex-1">{bonus.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
